module.exports = __webpack_public_path__ + "static/media/service-experience.8449b69d.png";